import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import logo from '../assets/logo.png';
import './CountdownPage.css';

const CountdownPage = () => {
  const navigate = useNavigate();
  const targetDate = new Date('2025-10-24T00:00:00').getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [showButton, setShowButton] = useState(false);
  const [celebrate, setCelebrate] = useState(false);

  // Countdown Logic
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const handleOctoberClick = () => {
    setShowButton(true);
  };

  const handleEnter = () => {
    // Trigger one-time elegant confetti
    setCelebrate(true);

    // Mark as seen and redirect after celebration
    localStorage.setItem('ceremonySeen', 'true');
    sessionStorage.setItem('showCelebration', 'true');

    setTimeout(() => {
      window.location.href = '/';
    }, 3200); // Enough time to enjoy the confetti
  };

  return (
    <>
      {/* Single, Clean Confetti Celebration - Only on Enter */}
      {celebrate && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={250}
          gravity={0.12}
          colors={['#8b5cf6', '#3b82f6', '#10b981', '#f59e0b', '#ef4444']}
          confettiSource={{ x: window.innerWidth / 2, y: 0 }}
        />
      )}

      <div className="countdown-page">
        {/* Minimal Background - No particles, balloons, gifts */}
        <div className="countdown-bg"></div>

        <div className="countdown-container">
          {/* Logo */}
          <div className="logo-section">
            <div className="logo-wrapper">
              <img src={logo} alt="Logo" className="countdown-logo" />
              <div className="logo-glow"></div>
            </div>
          </div>

          {/* Title */}
          <h1 className="countdown-title">
            Something <span className="highlight">Amazing</span> is Coming!
          </h1>

          <p className="countdown-subtitle">
            Join us for the grand opening on{' '}
            <span
              className="october-clickable"
              onClick={handleOctoberClick}
              title="Click to reveal entrance"
            >
              October
            </span>{' '}
            23, 2025
          </p>

          {/* Countdown Timer */}
          <div className="timer-container">
            <div className="timer-box">
              <div className="timer-value">{String(timeLeft.days).padStart(2, '0')}</div>
              <div className="timer-label">Days</div>
            </div>
            <span className="timer-separator">:</span>
            <div className="timer-box">
              <div className="timer-value">{String(timeLeft.hours).padStart(2, '0')}</div>
              <div className="timer-label">Hours</div>
            </div>
            <span className="timer-separator">:</span>
            <div className="timer-box">
              <div className="timer-value">{String(timeLeft.minutes).padStart(2, '0')}</div>
              <div className="timer-label">Minutes</div>
            </div>
            <span className="timer-separator">:</span>
            <div className="timer-box">
              <div className="timer-value">{String(timeLeft.seconds).padStart(2, '0')}</div>
              <div className="timer-label">Seconds</div>
            </div>
          </div>

          {/* Clean Ribbon Button - No emojis, gifts, or balloons */}
          {showButton && (
            <div className="ribbon-container">
              <button className="ribbon-button" onClick={handleEnter}>
                <span className="ribbon-text">Enter the New Website</span>
              </button>
              <div className="ribbon-left"></div>
              <div className="ribbon-right"></div>
            </div>
          )}

          {/* Event Info */}
          <div className="event-info">
            <p className="event-text">
              Shree Swami Samarth Seva Marg<br />
              <span className="event-highlight">Grand Opening Ceremony</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountdownPage;